export interface UserFeatureRef {
  source: 'user'
  featureId: string
}

export interface CotrexTrailRef {
  source: 'cotrex-trail'
  name: string
  placeId: number
  featureId: string
}

export interface CotrexTrailheadRef {
  source: 'cotrex-trailhead'
  name: string
  coordinates: [number, number]
}

export interface BackcountryTrailRef {
  source: 'backcountry-trail'
  name: string
}

export interface BackcountryPOIRef {
  source: 'backcountry-poi'
  name: string
  subclass: string
  coordinates: [number, number]
}

export interface CotrexClosureRef {
  source: 'cotrex-closure'
  name: string
}

export interface FireFeatureRef {
  source: 'fire'
  fireType: string
  name: string
}

export interface SearchResultRef {
  source: 'search'
  searchId: string
}

export type SelectableFeatureRef =
  | UserFeatureRef
  | CotrexTrailRef
  | CotrexTrailheadRef
  | CotrexClosureRef
  | FireFeatureRef
  | BackcountryTrailRef
  | BackcountryPOIRef
  | SearchResultRef

export function featureRefKey(ref: SelectableFeatureRef): string {
  switch (ref.source) {
    case 'user':
      return `user:${ref.featureId}`
    case 'cotrex-trail':
      if (ref.placeId) return `cotrex-trail:p${ref.placeId}`
      if (ref.featureId) return `cotrex-trail:f${ref.featureId}`
      return `cotrex-trail:n${ref.name}`
    case 'cotrex-trailhead':
      return `cotrex-trailhead:${ref.name}:${ref.coordinates[0]}:${ref.coordinates[1]}`
    case 'cotrex-closure':
      return `cotrex-closure:${ref.name}`
    case 'fire':
      return `fire:${ref.fireType}:${ref.name}`
    case 'backcountry-trail':
      return `backcountry-trail:${ref.name}`
    case 'backcountry-poi':
      return `backcountry-poi:${ref.subclass}:${ref.name}:${ref.coordinates[0]}:${ref.coordinates[1]}`
    case 'search':
      return `search:${ref.searchId}`
  }
}
